var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize",on:{"click":function($event){return _vm.handleRemind()}}},[_vm._v("Remind Payment Setup")])
}
var staticRenderFns = []

export { render, staticRenderFns }